import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Message } from 'src/app/models/message';
import { ContentNews } from 'src/app/models/obs/contentnews';
import { AccessService } from 'src/app/services/access.service';
import { ContentnewsService } from 'src/app/services/obs/contentnews.service';
import { NewsService } from 'src/app/services/obs/news.service';
import { TokenStorageService } from 'src/app/services/token-storage.service';

@Component({
  selector: 'app-admcontent-list',
  templateUrl: './admcontent-list.component.html',
  styleUrl: './admcontent-list.component.scss'
})
export class AdmcontentListComponent implements OnInit {

  cnews: ContentNews = null;
  msg: Message;
  idnewsSelected: string = null;

  constructor(
    private cnewS: ContentnewsService,
    private activedRoute: ActivatedRoute,
    private accesService: AccessService,
    private ts: TokenStorageService,
    private newS: NewsService
  ) { }

  ngOnInit() {
    const params = this.activedRoute.snapshot.params;
    this.idnewsSelected = params['idnews'];
    this.getTypeNewOrEvent(params['idnews']);
    this.get4News(params['idnews']);
  }

  typeEventNew: boolean = false
  //bandera que controla la creacion de contenido
  accessMP: boolean = false
  //bandera que controla la eliminacion de contenido
  accessME: boolean = false
  //bandera que controla la eliminacion de contenido
  accessMD: boolean = false
  /* Permite determinar si el usuario actual tiene permiso para el modulo */
  inf = {}

  getPermission() {
    const params = this.activedRoute.snapshot.params['idnews'];
    if (this.typeEventNew === false) {
      this.inf['accessId'] = 7;//noticias
    }
    if (this.typeEventNew === true) {
      this.inf['accessId'] = 8;//eventos
    }
    this.inf['userId'] = this.ts.getUser().id;
    const data = this.inf;
    this.accesService.getPermissionUser(data).subscribe({
      next: res => {
        this.accessMP = res['result'].createSection;
        this.accessME = res['result'].editSection;
        this.accessMD = res['result'].deleteSection;
      },
      error: err => {
        this.msg = err;
      }
    });
  }

  get4News(id: string) {
    this.cnewS.get4News(id).subscribe({
      next: res => {
        this.cnews = res['data'];
      },
      error: err => {
        this.msg = err;
      }
    });
  }

  getTypeNewOrEvent(id: string) {
    this.newS.getTypeNewOrEvent(id).subscribe({
      next: res => {
        this.typeEventNew = res['data'].type;
        this.getPermission();
      },
      error: err => {
        this.msg = err;
      }
    });
  }

}

